// extracted by mini-css-extract-plugin
export default {"infoIcon":"styles_infoIcon__-eqr-"};